function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmploymentAndJobs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.895,5.147L23.557,5.147C23.852,5.147 24.093,5.389 24.093,5.684L24.093,8.368L13.358,8.368L13.358,5.684C13.358,5.389 13.599,5.147 13.895,5.147ZM10.137,5.684L10.137,8.368L5.843,8.368C3.475,8.368 1.549,10.294 1.549,12.662L1.549,19.103L35.902,19.103L35.902,12.662C35.902,10.294 33.977,8.368 31.608,8.368L27.314,8.368L27.314,5.684C27.314,3.611 25.63,1.927 23.557,1.927L13.895,1.927C11.821,1.927 10.137,3.611 10.137,5.684ZM35.902,21.25L23.02,21.25L23.02,23.397C23.02,24.585 22.06,25.545 20.873,25.545L16.579,25.545C15.391,25.545 14.431,24.585 14.431,23.397L14.431,21.25L1.549,21.25L1.549,29.839C1.549,32.207 3.475,34.133 5.843,34.133L31.608,34.133C33.977,34.133 35.902,32.207 35.902,29.839L35.902,21.25Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmploymentAndJobs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/employment-and-jobs.e30c771f733489003fec6c7eeb6e7326.svg";